import { Property, PropertyDocumentBase } from '../models/proprety.model';

export class PropertyViewModel {
  private propertyDocumentBase: PropertyDocumentBase;
  private _propertiesByOT;
  private _propertiesByCategory: Map<string, Array<Property>>;
  private _namedPropertiesByOT;

  get propertiesByOT() {
    if (!this._propertiesByOT) {
      this._propertiesByOT = {};
      if (Array.isArray(this.propertyDocumentBase?.ObjectTypes)) {
        for (const ot of this.propertyDocumentBase?.ObjectTypes) {
          this._propertiesByOT[ot.id] = {};
          if (Array.isArray(ot.Properties)) {
            for (const property of ot.Properties) {
              this._propertiesByOT[ot.id][property.name] = property;
            }
          }
        }
      }
    }
    return this._propertiesByOT;
  }

  get namedPropertiesByOT() {
    if (!this._namedPropertiesByOT) {
      this._namedPropertiesByOT = {};
      for (const properties in this.propertiesByOT) {
        this._namedPropertiesByOT[properties] = {};
        for (const key in this.propertiesByOT[properties]) {
          if (Object.prototype.hasOwnProperty.call(this.propertiesByOT[properties], key)) {
            const property = this.propertiesByOT[properties][key];
            this._namedPropertiesByOT[properties][property.name] = property;
          }
        }
        // this.propertiesByOT[properties].forEach(property => {
        //     this._namedPropertiesByOT[properties][property.name] = property;
        // });
      }
    }
    return this._namedPropertiesByOT;
  }

  public getPropertiesByCategory(ot: string) {
    this._propertiesByCategory = new Map();
    const properties: Property[] = this.propertiesByOT[ot];
    if (properties) {
      for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
          const property = properties[key];
          const category = property.category || 'noCategory';
          if (this._propertiesByCategory.has(category)) {
            this._propertiesByCategory.get(category).push(property);
          } else {
            this._propertiesByCategory.set(category, [property]);
          }
        }
      }
    }
    return this._propertiesByCategory;
  }

  setPropertyVisibility(ot, properties) {
    const _properties = this.propertiesByOT[ot];
    for (const key in _properties) {
      if (Object.prototype.hasOwnProperty.call(_properties, key)) {
        if (this._propertiesByOT[ot][key]) {
          this._propertiesByOT[ot][key].visibility = properties[0][key] ?? 1;
        }
      }
    }
  }

  constructor(data) {
    this.propertyDocumentBase = data;
  }
}
